<template>
  <EventActionFieldRowComponent :label="t('components.TaskModal.commentUser')">
    <InputRow
      v-slot="{ validation: { valid } }"
      :model-value="modelValue"
      required
      name="commentatorId"
    >
      <SearchSelect
        ref="select"
        :model-value="modelValue ?? undefined"
        :mode="SelectMode.USER"
        :filters="
          siteId == null
            ? undefined
            : {
                hasRightsOnSite: {
                  siteIds: [siteId],
                  rights: SQDC_ASSING_MINIMUM_RIGHTS,
                },
              }
        "
        :state="valid"
        :required="true"
        :disabled="disabled"
        @update:model-value="handleInput"
      />
    </InputRow>
  </EventActionFieldRowComponent>
</template>

<script setup lang="ts">
import { useTranslation } from "@/language/translation";

import InputRow from "@/components/shared/form/InputRow.vue";
import { ref, onMounted, nextTick, type PropType } from "vue";
import store from "@/store";
import EventActionFieldRowComponent from "../../EventActionFieldRowComponent.vue";
import { useProvidedBoardContext } from "@/modules/sqdc/helper/EABConfigHelper";
import SearchSelect from "@/components/shared/searchSelects/SearchSelect.vue";
import { SelectMode } from "@/components/shared/searchSelects/SelectDefinitions";
import { SQDC_ASSING_MINIMUM_RIGHTS } from "../helper/SQDCHelper";

defineOptions({
  inheritAttrs: false,
});

defineProps({
  modelValue: {
    type: Number as PropType<number | null | undefined>,
    required: false,
    default: undefined,
  },
  labelCols: {
    type: String,
    default: "2",
  },
  labelClass: {
    type: String,
    default: "text-left",
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
});
const emit = defineEmits(["update:modelValue"]);

const isAnonym = ref<boolean>(store.getters["login/isAnonym"]);
const select = ref<InstanceType<any>>();

const userId = ref<null | number>(null);

async function handleInput(id: number | undefined) {
  emit("update:modelValue", id);
  select.value.$refs?.multiselect?.$refs?.multiSelectRef?.deactivate?.();
  select.value.$refs?.multiselect?.$refs?.multiSelectRef?.blur?.();
  if (id == null || isAnonym.value === false) {
    return;
  }
  await store.dispatch("taskComment/setTaskCommentatorId", id);
  await nextTick();
  select.value.$refs?.multiselect?.$refs?.multiSelectRef?.deactivate?.();
  select.value.$refs?.multiselect?.$refs?.multiSelectRef?.blur?.();
}

onMounted(() => {
  const commentatorId = store.getters["taskComment/getTaskCommentatorId"];
  if (userId.value == null && commentatorId != null) {
    userId.value = commentatorId;
    emit("update:modelValue", userId.value);
  }
});

const { siteId } = useProvidedBoardContext();

const { t } = useTranslation();
</script>

<style lang="scss" scoped></style>
